<template>
  <el-select
    :value="value"
    filterable
    clearable
    reserve-keyword
    placeholder="请输入关键词"
    value-key="projectId"
    :loading="loading"
    @click.native="search"
    @change="handleChange"
  >
    <el-option v-for="item in options" :key="item.projectId" :label="item.name" :value="item"></el-option>
  </el-select>
</template>
<script>
import { COMMON_PROJECT_RESOURCE_PROJECTS_DA } from "@/store/mutation-types";

export default {
  props: {
    value: [Object, String],
    subsystemId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      /* 远程搜索项目列表 */
      loading: false,
      options: []
    };
  },
  created() {
    if (this.value) {
      this.search();
    }
  },
  methods: {
    /* 项目远程搜索 */
    search() {
      this.loading = true;
      this.$store
        .dispatch(COMMON_PROJECT_RESOURCE_PROJECTS_DA, {
          subsystemId: this.subsystemId
        })
        .then(data => {
          this.loading = false;
          this.options = data;
        });
    },
    handleChange(value) {
      this.$emit("input", value);
    },
    getProjects() {
      return this.options;
    }
  }
};
</script>
